
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/releases",
      function () {
        return require("private-next-pages/tools/releases.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/releases"])
      });
    }
  